import i18n from 'i18next'

// React-free translate for plain .ts code that can run OUTSIDE an i18n-initialised
// context too: the offscreen document, the mobile-web RAILGUN worker and scan
// workers never call initI18nCore, and an uninitialised i18next returns
// `undefined` from t(). There we fall back to the English key (keys are the English
// sentence) with {{var}} interpolation, so the message is still correct English.
//
// Call it as `translation.t('…')` — the i18n extractor picks that form up.
const interpolate = (key: string, options?: Record<string, unknown>) =>
  key.replace(/{{\s*(\w+)\s*}}/g, (match, name: string) =>
    options && name in options ? String(options[name]) : match
  )

export const translation = {
  t: (key: string, options?: Record<string, unknown>): string => {
    if (i18n.isInitialized) {
      const translated = i18n.t(key, options as any) as unknown
      if (typeof translated === 'string' && translated) return translated
    }
    return interpolate(key, options)
  }
}
